import { UseMutateAsyncFunction, useMutation } from '@tanstack/react-query';
import { useNetworkRequest } from './useNetworkRequest';
import type { AxiosResponse, AxiosError } from 'axios';

interface ApiErrorResponse {
  message: string;
}

interface ExternalAccountResponse {
  id: string;
}

interface DirectDepositRequest {
  routing_number: string;
  account_number: string;
}

interface CardRequest {
  stripe_token: string;
}

const usePaymentInfo = (): {
  addCard: UseMutateAsyncFunction<
    AxiosResponse<ExternalAccountResponse>,
    AxiosError<ApiErrorResponse>,
    CardRequest,
    unknown
  >;
  addDirectDeposit: UseMutateAsyncFunction<
    AxiosResponse<ExternalAccountResponse>,
    AxiosError<ApiErrorResponse>,
    DirectDepositRequest,
    unknown
  >;
  isAddDirectDepositLoading: boolean;
  isAddCardLoading: boolean;
} => {
  const { axios } = useNetworkRequest();

  const { mutateAsync: addDirectDeposit, isPending: isAddDirectDepositLoading } = useMutation<
    AxiosResponse<ExternalAccountResponse>,
    AxiosError<ApiErrorResponse>,
    DirectDepositRequest
  >((values: DirectDepositRequest) =>
    axios.post('/v3/professional/external_accounts', {
      external_account: {
        routing_number: values.routing_number,
        account_number: values.account_number,
        type: 'bank_account',
      },
    }),
  );

  const { mutateAsync: addCard, isPending: isAddCardLoading } = useMutation<
    AxiosResponse<ExternalAccountResponse>,
    AxiosError<ApiErrorResponse>,
    CardRequest
  >((values: CardRequest) =>
    axios.post('/v3/professional/external_accounts', {
      external_account: {
        stripeToken: values.stripe_token,
      },
    }),
  );

  return {
    addCard,
    addDirectDeposit,
    isAddDirectDepositLoading,
    isAddCardLoading,
  };
};

export default usePaymentInfo;
